<template>
  <div>
    <ReturnArchiveModal3 :returnPDF = "returnedPDF" :isLoading = "modal3IsLoading"/>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">{{ translations('navbar.purchase_management') }}</a></li>
        <li class="breadcrumb-item active" aria-current="page">{{ translations('return_partner.archive_manufacturer_return') }}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-2">
        <div class="form-group mr-2">
          <router-link class="btn btn-primary" to="new-return-partners">{{ translations('common.addition') }}</router-link>
        </div>
        <div class="form-group mr-3">
          <input type="text" class="form-control" v-model="dtSearch" :placeholder="translations('common.keyword_search')">
        </div>
        <div class="form-group">
          <span class="mr-2">{{ translations('common.period') }}</span>
          <button @click="setFilterLastMonth()" class="btn btn-secondary mr-1 mb-2 mb-md-0" :disabled="true">{{ translations('return_partner.previous_month') }}</button>
          <button @click="setFilterCurrentMonth()" class="btn btn-info mr-3 mb-2 mb-md-0" :disabled="true">{{ translations('return_partner.current_month') }}</button>
<!--          <input type="date" v-model="dateFrom" class="form-control" @blur='triggerDateFilter("dateFrom")' @focus="tempDateFromField = dateFrom">-->
          <input type="date" v-model="dateFrom" class="form-control">
          <span class="mr-1 ml-1">〜</span>
<!--          <input type="date" v-model="dateTo" class="form-control" @blur='triggerDateFilter("dateTo")' @focus="tempDateToField = dateTo">-->
          <input type="date" v-model="dateTo" class="form-control">
        </div>
      </div>
      <div class="form-inline mb-4 justify-content-between">
        <div class="d-flex flex-wrap align-items-center">
        <div class="form-group mr-2">
          <div class="dropdown">
            <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ getFilterTxt (master_partners, searchParam.manufacturers_id, 'name', translations('return_partner.manufacturer')) }}
            </button>
            <div class="dropdown-menu" style="max-height: 200px; overflow-y: auto;">
              <a @click.self="selectFilterArg('manufacturers_id', '')" class="dropdown-item" href="#">&nbsp;</a>
              <template v-for="(partner, i) in master_partners">
                <a :key="i" @click.self="selectFilterArg('manufacturers_id', partner.id)" class="dropdown-item" href="#">{{ partner.name }}</a>
              </template>
            </div>
          </div>
        </div>
          <div class="form-group mr-2">
            <div class="dropdown">
              <button id='filterByBilling' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ getFilterTxt (translatedTypePartner, selectedTypePartner, 'name', translations('return_partner.all')) }}
              </button>
              <div class="dropdown-menu">
                <a class='dropdown-item' v-for='(type, i) in translatedTypePartner' :key='i' v-on:click='selectedTypePartner=type.id'>{{ type.name }}</a>
              </div>
            </div>
          </div>
        <div class="form-group mr-3">
          <div class="dropdown">
            <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ getFilterTxt (master_mywarehouses, searchParam.warehouse_id, 'name', translations('return_partner.warehouse')) }}
            </button>
            <div class="dropdown-menu" style="max-height: 200px; overflow-y: auto;">
              <a @click.self="selectFilterArg('warehouse_id', '')" class="dropdown-item" href="#">&nbsp;</a>
              <template v-for="(mywarehouse, i) in master_mywarehouses">
                <a :key="i" @click.self="selectFilterArg('warehouse_id', mywarehouse.id)" class="dropdown-item" href="#">{{ mywarehouse.name }}</a>
              </template>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="form-check">
            <input class="form-check-input" v-model="searchParam.show_completed" type="checkbox" value="" id="defaultCheck1">
            <label class="form-check-label" for="defaultCheck1">
              {{ translations('return_partner.also_display_processed') }}
            </label>
          </div>
        </div>
        <div class="form-group ml-2">
          <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{ translations('common.search') }}</button>
        </div>
          <div class="form-group ml-2">
            <button class="btn btn-primary btn-sm" type="button" @click="exportCsv">{{translations('common.csv_export')}}</button>
          </div>
        </div>
<!--        <div class="form-group">-->
<!--          <a href="#" @click.self="export_csv_eng()" class="btn btn-sm btn-link decoration-underline">{{ translations('return_partner.export_return_csv') }}</a>-->
<!--          <a href="#" @click.self="export_csv()" class="btn btn-sm btn-link decoration-underline">{{ translations('return_partner.export_csv') }}</a>-->
<!--        </div>-->
      </div>
      <div class="table-scroll mb-4 table-return">
        <v-data-table
          class="table table-striped table-hover table-2000 table-clickable"
          item-key="name"
          :headers="[
            { text: 'No', value: '', sortable: false },
            { text: translations('return_partner.applied_date'), value: 'applied_at' },
            { text: translations('return_partner.shipped_date'), value: 'shipped_at' },
            { text: translations('return_partner.approved_date'), value: 'approved_at' },
            { text: translations('return_partner.offset_date'), value: 'offset_at' },
            { text: translations('return_partner.organization_number'), value: 'reference_number' },
            { text: translations('return_partner.manufacturer'), value: 'kaishu_partner_name' },
            { text: translations('return_partner.product_condition'), value: 'type_product' },
            { text: translations('return_partner.warehouse'), value: 'kaishu_warehouse_name' },
            { text: translations('return_partner.model_number'), value: 'model' },
            { text: translations('return_partner.quantity'), value: 'quantity' },
            { text: translations('return_partner.unit_price'), value: 'unit_price' },
            { text: translations('return_partner.summary'), value: 'remarks' },
            { text: translations('return_partner.cost_price'), value: 'row_price' },
            { text: translations('return_partner.verification_results'), value: 'test_result' }
          ]"
          :items="returns"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <template v-if="!isEmpty">
                <tr  v-for='(ret, i) in items' :key="i" data-href="" @click="openReturnPartnerDetails(ret,$event)">
                  <td>{{ i+1 }}</td>
                  <td>{{ $invoiceTools.formatDate(ret.applied_at) }}</td>
                  <td>{{ $invoiceTools.formatDate(ret.shipped_at) }}</td>
                  <td>{{ $invoiceTools.formatDate(ret.approved_at) }}</td>
                  <td>{{ $invoiceTools.formatDate(ret.offset_at) }}</td>
                  <td>{{ ret.reference_number }}</td>
                  <td>{{ ret.partner_name }}</td>
                  <td>
                    <ul>
                      <li v-for="(detail, ii) in ret.details" :key="ii">
                        {{ getStatusLabel(detail.type_product) }}
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li v-for="(detail, iii) in ret.details" :key="iii">
                        {{ detail.warehouse_name }}
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li v-for="(detail, iv) in ret.details" :key="iv">
                        {{ detail.model || '-' }}
                      </li>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <li v-for="(detail, v) in ret.details" :key="v">
                        {{ $invoiceTools.parseTxtNum(detail.quantity) }}
                      </li>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <li v-for="(detail, vi) in ret.details" :key="vi">
                        {{ $invoiceTools.parseTxtNum(detail.unit_price) }}
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li v-for="(detail, vii) in ret.details" :key="vii">
                        {{ detail.remarks || '-' }}
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li v-for="(detail, viii) in ret.details" :key="viii">
                        {{ $invoiceTools.parseTxtNum(detail.row_price) }}
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li v-for="(detail, ix) in ret.details" :key='ix'>
                        {{ detail.test_result || '-' }}
                      </li>
                    </ul>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr class="odd">
                  <td valign="top" colspan="15" class="dataTables_empty">{{ isEmptyMsg }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
    </div>
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import ReturnArchiveModal3 from '@/components/ReturnArchiveModal3'
import { saveAs } from 'file-saver'
import $ from 'jquery'
import { Condition } from '../constants'
import { mapState } from 'vuex'
import Papa from 'papaparse'
import encoding from 'encoding-japanese'

export default {
  name: 'ArchiveReturnPartners',
  props: {},
  components: {
    VueElementLoading,
    ReturnArchiveModal3
  },
  data () {
    return {
      returns: [],
      adminStatus: [],
      dateFrom: '',
      dateTo: '',
      tempDateFromField: '',
      tempDateToField: '',
      dtSearch: '',
      searchParam: {
        manufacturers_id: '',
        warehouse_id: '',
        show_completed: '',
        start_at: '',
        end_at: ''
      },
      isSearching: false,
      makers: [],
      bill: {},
      warehouse: {},
      partners: {},
      isEmpty: false,
      isEmptyMsg: '',
      returnIds: [],
      returnedPDF: [],
      modal3IsLoading: false,
      csvField: [],
      page: 1,
      pageCount: 0,
      totalCount: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      stopWatch: false,
      typePartner: [
        { id: 'all', name: '全部' },
        { id: 'overseas', name: '海外' },
        { id: 'domestic', name: '国内' }
      ],
      selectedTypePartner: 'all'
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    return_reasons () {
      return this.$store.getters['Return/getReasons']
    },
    return_states () {
      const states = this.$store.getters['Return/getStates']
      return this.translateStates(states)
    },
    master_mywarehouses () {
      return this.$store.getters['Master/getMywarehouses']
    },
    master_partners () {
      if (this.selectedTypePartner === 'overseas') {
        return this.$store.getters['Master/getPayOverseasTo']
      } else if (this.selectedTypePartner === 'domestic') {
        return this.$store.getters['Master/getPayTo']
      } else {
        const partnerOverseas = this.$store.getters['Master/getPayOverseasTo']
        const partnerDomestic = this.$store.getters['Master/getPayTo']
        return [...new Set([...partnerOverseas, ...partnerDomestic])]
      }
    },
    translatedTypePartner () {
      return this.typePartner.map(condition => {
        return {
          id: condition.id,
          name: this.translations(`return_partner.${condition.id}`)
        }
      })
    }
  },
  watch: {
    searchParam: {
      handler (v) {
        // if (!this.stopWatch) {
        //   this.initList('searchParam')
        // }
      },
      deep: true
    },
    page () {
      this.getFilterList()
    },
    options: {
      handler () {
        if (!this.stopWatch) {
          this.initList('options')
        }
      },
      deep: true
    },
    selectedTypePartner (newVal, oldVal) {
      if (this.stopWatch) return
      this.searchParam.manufacturers_id = null
    }
  },
  created () {
    this.stopWatch = true
    this.$store.dispatch('Return/checkReasons')
    this.$store.dispatch('Return/checkStates')
    this.$store.dispatch('Master/checkMywarehouses')
    this.$store.dispatch('Master/checkPayOverseasTo')
    this.$store.dispatch('Master/checkPayTo')

    const storedFilter = this.$storage.get('returnFltrParam')
    const sortParams = this.$storage.get('returnFltrSortParam')

    if (storedFilter) {
      this.dtSearch = storedFilter.search
      this.searchParam = storedFilter
      this.warehouse.id = storedFilter.warehouse_id
      this.partners.id = storedFilter.manufacturers_id
      this.dateFrom = storedFilter.start_at
      this.dateTo = storedFilter.end_at
      this.selectedTypePartner = storedFilter.type_partner
      if (sortParams) {
        this.options.sortBy = sortParams.orderbys
        this.options.sortDesc = sortParams.is_descs
      }

      this.initList('created')
    } else {
      this.setFilterCurrentMonth()
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    translateStates (states) {
      return states.map(state => ({
        ...state,
        name: this.translations(`states.${state.name}`)
      }))
    },
    hidePopUpAdminStatus () {
      $('.popclose-all').hide()

      $('.table-return .v-data-table__wrapper').css({
        'overflow-y': 'auto'
      })
      $('.table-return').css({
        'overflow-x': 'scroll'
      })
    },

    initList (call) {
      if (this.page !== 1) {
        this.page = 1
      } else {
        if (call === 'created') {
          let { page } = this.$router.history.current.query
          this.page = page ? parseInt(page) : 1
        }
        this.getFilterList()
      }
    },

    getFilterList (field, val) {
      this.hidePopUpAdminStatus()
      if (this.isSearching) {
        return
      }

      this.isSearching = true

      const params = JSON.parse(JSON.stringify(this.searchParam))

      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      params.offset = offset
      params.limit = limit
      params.orderbys = orderbys
      params.is_descs = isDescs
      params.search = this.dtSearch
      params.start_at = (this.dateFrom) ? this.dateFrom : ''
      params.end_at = (this.dateTo) ? this.dateTo : ''
      params.type_partner = this.selectedTypePartner

      this.$storage.set('returnFltrSortParam', params)
      this.$storage.set('returnFltrParam', params)

      this.$http.post(this.$api_url.return_partner_list, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.returns = result.list
          this.totalCount = Number(result.total_count)
        } else {
          this.returns = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(error => {
        console.log('ArchiveReturn:API:getFilterList: error: ', error)
        this.isEmpty = true
        this.isEmptyMsg = this.translations('return_partner.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        if (this.stopWatch === true) {
          this.stopWatch = false
        }
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    selectFilterArg (filter, val) {
      console.log(this.searchParam)
      this.searchParam[filter] = val
    },

    getFilterTxt (obj, input, output, _default) {
      if (input === 0 || input) {
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    setFilterCurrentMonth () {
      const $date = new Date()
      const y = $date.getFullYear()
      const m = ('0' + ($date.getMonth() + 1)).slice(-2)
      const ld = new Date(y, m, 0)
      const start = y + '-' + m + '-01'
      const end = y + '-' + m + '-' + ('0' + ld.getDate()).slice(-2)

      this.dateFrom = start
      this.dateTo = end

      this.tempDateFromField = this.dateFrom
      this.tempDateToField = this.dateTo

      this.searchParam.start_at = this.dateFrom
      this.searchParam.end_at = this.dateTo
      this.initList()
    },

    setFilterLastMonth () {
      const $date = new Date()
      const m = ($date.getMonth() !== 0) ? ('0' + ($date.getMonth())).slice(-2) : 12
      const y = (m !== 12) ? $date.getFullYear() : $date.getFullYear() - 1
      const ld = new Date(y, m, 0)
      const start = y + '-' + m + '-01'
      const end = y + '-' + m + '-' + ('0' + ld.getDate()).slice(-2)

      this.dateFrom = start
      this.dateTo = end

      this.tempDateFromField = this.dateFrom
      this.tempDateToField = this.dateTo

      this.searchParam.start_at = this.dateFrom
      this.searchParam.end_at = this.dateTo
      this.initList()
    },

    openReturnPartnerDetails (ret, event) {
      if ($(event.target).parents('td')[0] && $(event.target).parents('td')[0].getAttribute('data-action') === 'true') {
        return false
      }
      this.$router.push({ name: 'single-return-partners', query: { return_partner_id: ret.id, pageBack: this.page } })
    },

    getStatusLabel (typeProduct) {
      if (Number(typeProduct) === Condition.BAD) {
        return this.translations('return_partner.bad')
      } else if (Number(typeProduct) === Condition.OUTLET) {
        return this.translations('return_partner.outlet')
      } else {
        return this.translations('return_partner.good')
      }
    },

    submitSearch () {
      if (!this.stopWatch) {
        this.initList('searchParam')
      }
      this.initList('changeSearch')
      this.initList('triggerDateFilter')
    },

    exportCsv (field, val) {
      this.hidePopUpAdminStatus()
      if (this.isSearching) {
        return
      }

      this.isSearching = true

      const params = JSON.parse(JSON.stringify(this.searchParam))
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      params.orderbys = orderbys
      params.is_descs = isDescs
      params.search = this.dtSearch
      params.start_at = (this.dateFrom) ? this.dateFrom : ''
      params.end_at = (this.dateTo) ? this.dateTo : ''
      params.type_partner = this.selectedTypePartner

      this.$storage.set('returnFltrSortParam', params)
      this.$storage.set('returnFltrParam', params)

      this.$http.post(this.$api_url.return_partner_csv, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.saveCsv_(result.list)
        } else {
          this.returns = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(error => {
        console.log('ArchiveReturn:API:getFilterList: error: ', error)
        this.isEmpty = true
        this.isEmptyMsg = this.translations('return_partner.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        if (this.stopWatch === true) {
          this.stopWatch = false
        }
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    saveCsv_ (list) {
      const data = []
      list.forEach(item => {
        item.details.forEach(detail => {
          data.push([
            item.applied_at,
            item.shipped_at,
            item.approved_at,
            item.offset_at,
            item.reference_number,
            item.partner_name,
            this.getStatusLabel(detail.type_product),
            detail.warehouse_name,
            detail.model,
            detail.quantity,
            detail.unit_price,
            detail.remarks,
            detail.row_price,
            detail.test_result
          ])
        })
      })
      let csv = ''
      csv = Papa.unparse({
        fields: [
          this.translations('return_partner.applied_date'),
          this.translations('return_partner.shipped_date'),
          this.translations('return_partner.approved_date'),
          this.translations('return_partner.offset_date'),
          this.translations('return_partner.organization_number'),
          this.translations('return_partner.manufacturer'),
          this.translations('return_partner.product_condition'),
          this.translations('return_partner.warehouse'),
          this.translations('return_partner.model_number'),
          this.translations('return_partner.quantity'),
          this.translations('return_partner.unit_price'),
          this.translations('return_partner.summary'),
          this.translations('return_partner.cost_price'),
          this.translations('return_partner.verification_results')
        ],
        data: data
      })
      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv' })
      const d = new Date()
      const filename = this.translations('return_partner.manufacturer_returns_') + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'
      saveAs(content, filename)
      this.isLoading = false
    }
  }
}
</script>

<style>
#tbl-returns{
  margin-top: 0 !important
}
.td-status-admin {
  position: relative;
}
.show_status {
  margin-left:5px;
  color:red;
}
.list-status {
  width: 160px;
  display: flex;
  margin-bottom: 5px;
}
.admin-name {
  width: 60%;
}
.popover-x.right > .arrow.status {
  left: -15px;
}
.popover-body.status {
  padding: 20px;
  background: #fff;
}
.close.status {
    position: absolute;
    top: 0;
    right: 3px;
}
.text-status {
  color: #106710;
}
.isShowButtonApproved {
  position: absolute;
  top: 0;
  right: 0;
}
.form-line-po {
  position: relative;
}
.td-status-admin .popover {
  top: 0;
  left: 95px;
}
.td-status-admin .popover-body::after{
    z-index: -10;
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    margin-left: 0;
    bottom: 0;
    top: 20px;
    left:0;
    box-sizing: border-box;
    border: 7px solid #fff;
    border-color: transparent transparent #fff #fff;
    transform-origin: 0 0;
    transform: rotate(45deg);
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.4);
  }
.td-status-admin .popover-body::before{
    z-index: 10;
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    margin-left: 0;
    bottom: 0;
    top: 20px;
    left:0;
    box-sizing: border-box;
    border: 7px solid black;
    border-color: transparent transparent #fff #fff;
    transform-origin: 0 0;
    transform: rotate(45deg);
  }
  .table-return .v-data-table__wrapper {
    overflow-y:auto;
  }
  .table-return .table-scroll {
    overflow-x:auto;
  }
</style>
